import React from "react";
import ExternalLinkIcon from "../../assets/images/ExternalLink.svg";
import { gtmPush } from "../../analytics/useGtmPageview.tsx";
interface ExternalLinkProps {
  href: string;
  text: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  icon?: string;
  width?: number;
  height?: number;
  iconSize?: number;
  showIcon?: boolean;
  textStyle?: React.CSSProperties;
  // optional overrides for analytics
  gtmEventName?: string;                    // default: "external_link_click"
  gtmParams?: Record<string, any>;          // extra params to merge
}

const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  text,
  onClick,
  className = "",
  icon,
  width = 20.572,
  height = 18,
  showIcon = true,
  textStyle,
  gtmEventName = "external_link_click",
  gtmParams = {},
}) => {
  const iconToRender = icon || ExternalLinkIcon;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 🔹 Push GTM event
    let domain = "";
    try {
      domain = new URL(href, window.location.href).hostname;
    } catch {}
    gtmPush(gtmEventName, {
      link_url: href,
      link_text: text,
      link_domain: domain,
      link_target: "_blank",
      icon_present: !!showIcon,
      page_path: window.location.pathname + window.location.search,
      component: "ExternalLink",
      ...gtmParams, // allow caller overrides
    });

    // 🔹 Call parent onClick if provided
    onClick?.(e);
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      className={`external-link ${className}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="external-link-text" style={{ ...textStyle }}>
        <span>{text}</span>
        <span>
          {showIcon && (
            <img
              src={iconToRender}
              width={width}
              height={height}
              alt="external link"
            />
          )}
        </span>
      </span>
    </a>
  );
};

export default ExternalLink;
